import { AbstractRouter } from "../../Router";
import { DailyReport } from "../../DailyReport";
import { Properties } from "../../../common/properties";
import { RealtimeReport } from "../../RealtimeReport";
import { RealtimeCcuReport } from "./SeaBank.RealtimeCcuReport";
import { DepositByTypeRealtimeReport } from "./SeaBank.RealtimeDepositByTypeReport";
import { DepositByTypeDailyReport } from "./SeaBank.DailyDepositByTypeReport";


class SeaBankRouter extends AbstractRouter {

    getConfigDicts() {
        let txnConfigDicts = this.getTxnConfigDicts();
        let tpvConfigDicts = this.getTpvConfigDicts();
        let txnInVsOutConfigDicts = this.getTxnInVsOutConfigDicts();
        let tpvInVsOutConfigDicts = this.getTpvInVsOutConfigDicts();
        let txnInConfigDicts = this.getTxnInConfigDicts();
        let tpvInConfigDicts = this.getTpvInConfigDicts();
        let txnOutConfigDicts = this.getTxnOutConfigDicts();
        let tpvOutConfigDicts = this.getTpvOutConfigDicts();
        let NewCustomerConfigDicts = this.getNewCustomerConfigDicts();
        let NewRegisterConfigDicts = this.getNewRegisterConfigDicts();
        let DepositConfigDicts = this.getDepositConfigDicts();
        let DepositChangeConfigDicts = this.getDepositChangeConfigDicts();
        let CcuConfigDicts = this.getCcuConfigDicts();
        let NewTxnUserDicts = this.getNewTxnUserConfigDicts();
        let ActiveUserDicts = this.getActiveUserConfigDicts();
        let loanConfigDicts = this.getLoanConfigDicts();
        let borrowerDicts = this.getBorrowerConfigDicts();
        let investmentDicts = this.getInvestmentConfigDicts();
        let cardDicts = this.getCardConfigDicts();
        let ExistingUserDicts = this.getExistingUserConfigDicts();

        return [
            ...txnConfigDicts,
            ...tpvConfigDicts,
            ...txnInVsOutConfigDicts,
            ...tpvInVsOutConfigDicts,
            ...txnInConfigDicts,
            ...tpvInConfigDicts,
            ...txnOutConfigDicts,
            ...tpvOutConfigDicts,
            ...NewCustomerConfigDicts,
            ...NewRegisterConfigDicts,
            ...DepositConfigDicts,
            ...DepositChangeConfigDicts,
            ...CcuConfigDicts,
            ...NewTxnUserDicts,
            ...ActiveUserDicts,
            ...loanConfigDicts,
            ...borrowerDicts,
            ...investmentDicts,
            ...cardDicts,
            ...ExistingUserDicts,
        ];
    }

    getTxnConfigDicts() {
        return [
            {
                metric: 'txn',
                reportLabel: 'Txn',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },

            {
                metric: 'txn',
                reportLabel: 'Txn',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
        ]
    }

    getTpvConfigDicts() {
        return [
            {
                metric: 'tpv',
                reportLabel: 'TPV',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'tpv',
                reportLabel: 'TPV',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },

        ]
    }

    getTxnInVsOutConfigDicts() {
        return [
            {
                metric: 'txn_in_vs_out',
                reportLabel: 'In & Out',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },

            {
                metric: 'txn_in_vs_out',
                reportLabel: 'In & Out',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
        ]
    }

    getTpvInVsOutConfigDicts() {
        return [
            {
                metric: 'tpv_in_vs_out',
                reportLabel: 'In & Out',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'tpv_in_vs_out',
                reportLabel: 'In & Out',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },

        ]
    }

    getTxnInConfigDicts() {
        return [
            {
                metric: 'txn_in',
                reportLabel: 'Transfer From',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },

            {
                metric: 'txn_in',
                reportLabel: 'Transfer From',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
        ]
    }

    getTpvInConfigDicts() {
        return [
            {
                metric: 'tpv_in',
                reportLabel: 'Transfer From',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'tpv_in',
                reportLabel: 'Transfer From',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },

        ]
    }
    getTxnOutConfigDicts() {
        return [
            {
                metric: 'txn_out',
                reportLabel: 'Transfer To',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },

            {
                metric: 'txn_out',
                reportLabel: 'Transfer To',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
        ]
    }

    getTpvOutConfigDicts() {
        return [
            {
                metric: 'tpv_out',
                reportLabel: 'Transfer To',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'tpv_out',
                reportLabel: 'Transfer To',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },

        ]
    }
    getNewCustomerConfigDicts() {
        return [
            {
                metric: 'new_customer',
                reportLabel: 'New Customer',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },

            {
                metric: 'new_customer',
                reportLabel: 'New Customer',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },

            {
                metric: 'new_customer_by_type',
                reportLabel: 'User Type',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },

            {
                metric: 'new_customer_by_type',
                reportLabel: 'User Type',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            }
        ]
    }
    getNewRegisterConfigDicts() {
        return [
            {
                metric: 'new_register',
                reportLabel: 'New Register',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },

            {
                metric: 'new_register',
                reportLabel: 'New Register',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },

            {
                metric: 'new_register_by_type',
                reportLabel: 'User Type',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },

            {
                metric: 'new_register_by_type',
                reportLabel: 'User Type',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            }
        ]
    }

    getDepositConfigDicts() {
        return [
            {
                metric: 'deposit',
                reportLabel: 'Deposit',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'deposit',
                reportLabel: 'Deposit',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'deposit_by_type',
                reportLabel: 'Consumer & Corp',
                frequency: Properties.frequencyBit.realtime,
                reportClass: DepositByTypeRealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'deposit_by_type',
                reportLabel: 'Consumer & Corp',
                frequency: Properties.frequencyBit.daily,
                reportClass: DepositByTypeDailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'deposit_consumer_by_type',
                reportLabel: 'Sav & TD',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'deposit_consumer_by_type',
                reportLabel: 'Sav & TD',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'deposit_corp_by_type',
                reportLabel: 'Sav & TD',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'deposit_corp_by_type',
                reportLabel: 'Sav & TD',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'deposit_sme_by_type',
                reportLabel: 'Sav & TD',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'deposit_sme_by_type',
                reportLabel: 'Sav & TD',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'deposit_group_by_type',
                reportLabel: 'Currency',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'deposit_group_by_type',
                reportLabel: 'Currency',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'deposit_consumer_saving_by_type',
                reportLabel: 'Currency',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'deposit_consumer_saving_by_type',
                reportLabel: 'Currency',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'deposit_sme_saving_by_type',
                reportLabel: 'Currency',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'deposit_sme_saving_by_type',
                reportLabel: 'Currency',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
        ]
    }

    getDepositChangeConfigDicts() {
        return [
            {
                metric: 'deposit_change',
                reportLabel: 'Deposit Change',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'deposit_change',
                reportLabel: 'Deposit Change',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'deposit_change_by_type',
                reportLabel: 'Consumer & Corp',
                frequency: Properties.frequencyBit.realtime,
                reportClass: DepositByTypeRealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'deposit_change_by_type',
                reportLabel: 'Consumer & Corp',
                frequency: Properties.frequencyBit.daily,
                reportClass: DepositByTypeDailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'deposit_change_consumer_by_type',
                reportLabel: 'Sav & TD',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'deposit_change_consumer_by_type',
                reportLabel: 'Sav & TD',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'deposit_change_corp_by_type',
                reportLabel: 'Sav & TD',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'deposit_change_corp_by_type',
                reportLabel: 'Sav & TD',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'deposit_change_sme_by_type',
                reportLabel: 'Sav & TD',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'deposit_change_sme_by_type',
                reportLabel: 'Sav & TD',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'deposit_change_group_by_type',
                reportLabel: 'Currency',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'deposit_change_group_by_type',
                reportLabel: 'Currency',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'deposit_change_consumer_saving_by_type',
                reportLabel: 'Currency',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'deposit_change_consumer_saving_by_type',
                reportLabel: 'Currency',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'deposit_change_sme_saving_by_type',
                reportLabel: 'Currency',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'deposit_change_sme_saving_by_type',
                reportLabel: 'Currency',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
        ]
    }

    getCcuConfigDicts() {
        return [
            {
                metric: 'ccu',
                reportLabel: 'CCU',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeCcuReport,
                productGroup: 'money_api',
            },
        ]
    }

    getNewTxnUserConfigDicts() {
        return [
            {
                metric: 'biz_txn_new_user',
                reportLabel: 'New Txn User',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'new_txn_user',
                reportLabel: 'New APP Txn User',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
        ]
    }
    getActiveUserConfigDicts() {
        return [
            {
                metric: 'active',
                reportLabel: 'DAU',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
        ]
    }

    getLoanConfigDicts() {
        return [
            {
                metric: 'loan_outstanding',
                reportLabel: 'Loan Outstanding',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'loan_outstanding',
                reportLabel: 'Loan Outstanding',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'loan_outstanding_change',
                reportLabel: 'Loan Outstanding Change',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'loan_outstanding_change',
                reportLabel: 'Loan Outstanding Change',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'loan_disbursement',
                reportLabel: 'Loan Disbursement',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'loan_disbursement',
                reportLabel: 'Loan Disbursement',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'loan_repayment',
                reportLabel: 'Loan Repayment',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'loan_repayment',
                reportLabel: 'Loan Repayment',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'loan_outstanding_by_type',
                reportLabel: 'Loan Type',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'loan_outstanding_by_type',
                reportLabel: 'Loan Type',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'loan_outstanding_mari_by_type',
                reportLabel: 'Non Split Txn vs Split Payment',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'loan_outstanding_mari_by_type',
                reportLabel: 'Non Split Txn vs Split Payment',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'loan_outstanding_non_split_txn_by_type',
                reportLabel: 'Interest-free vs Revolving',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'loan_outstanding_non_split_txn_by_type',
                reportLabel: 'Interest-free vs Revolving',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'loan_outstanding_split_payment_by_type',
                reportLabel: 'Interest-free vs Revolving',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'loan_outstanding_split_payment_by_type',
                reportLabel: 'Interest-free vs Revolving',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'loan_outstanding_split_bill_by_type',
                reportLabel: 'Interest-free vs Revolving',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'loan_outstanding_split_bill_by_type',
                reportLabel: 'Interest-free vs Revolving',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'loan_outstanding_cashloan_by_type',
                reportLabel: 'Instant Loan vs Balance Transfer',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'loan_outstanding_cashloan_by_type',
                reportLabel: 'Instant Loan vs Balance Transfer',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'loan_outstanding_change_by_type',
                reportLabel: 'Loan Type',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'loan_outstanding_change_by_type',
                reportLabel: 'Loan Type',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'loan_outstanding_change_mari_by_type',
                reportLabel: 'Non Split Txn vs Split Payment',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'loan_outstanding_change_mari_by_type',
                reportLabel: 'Non Split Txn vs Split Payment',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'loan_outstanding_change_non_split_txn_by_type',
                reportLabel: 'Interest-free vs Revolving',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'loan_outstanding_change_non_split_txn_by_type',
                reportLabel: 'Interest-free vs Revolving',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'loan_outstanding_change_split_payment_by_type',
                reportLabel: 'Interest-free vs Revolving',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'loan_outstanding_change_split_payment_by_type',
                reportLabel: 'Interest-free vs Revolving',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'loan_outstanding_change_split_bill_by_type',
                reportLabel: 'Interest-free vs Revolving',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'loan_outstanding_change_split_bill_by_type',
                reportLabel: 'Interest-free vs Revolving',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'loan_outstanding_change_cashloan_by_type',
                reportLabel: 'Instant Loan vs Balance Transfer',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'loan_outstanding_change_cashloan_by_type',
                reportLabel: 'Instant Loan vs Balance Transfer',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'loan_disbursement_by_type',
                reportLabel: 'Loan Type',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'loan_disbursement_by_type',
                reportLabel: 'Loan Type',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'loan_disbursement_mari_by_type',
                reportLabel: 'Non Split Txn vs Split Payment',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'loan_disbursement_mari_by_type',
                reportLabel: 'Non Split Txn vs Split Payment',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'loan_disbursement_cashloan_by_type',
                reportLabel: 'Instant Loan vs Balance Transfer',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'loan_disbursement_cashloan_by_type',
                reportLabel: 'Instant Loan vs Balance Transfer',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'loan_repayment_by_type',
                reportLabel: 'Loan Type',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'loan_repayment_by_type',
                reportLabel: 'Loan Type',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'loan_repayment_mari_by_type',
                reportLabel: 'Non Split Txn vs Split Payment',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'loan_repayment_mari_by_type',
                reportLabel: 'Non Split Txn vs Split Payment',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'loan_repayment_cashloan_by_type',
                reportLabel: 'Instant Loan vs Balance Transfer',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'loan_repayment_cashloan_by_type',
                reportLabel: 'Instant Loan vs Balance Transfer',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'loan_outstanding_sme_by_type',
                reportLabel: 'RCF vs Term Loan',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'loan_outstanding_sme_by_type',
                reportLabel: 'RCF vs Term Loan',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'loan_outstanding_change_sme_by_type',
                reportLabel: 'RCF vs Term Loan',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'loan_outstanding_change_sme_by_type',
                reportLabel: 'RCF vs Term Loan',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'loan_disbursement_sme_by_type',
                reportLabel: 'RCF vs Term Loan',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'loan_disbursement_sme_by_type',
                reportLabel: 'RCF vs Term Loan',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'loan_repayment_sme_by_type',
                reportLabel: 'RCF vs Term Loan',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'loan_repayment_sme_by_type',
                reportLabel: 'RCF vs Term Loan',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'loan_outstanding_credit_by_type',
                reportLabel: 'Shopee vs Non-Shopee',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'loan_outstanding_credit_by_type',
                reportLabel: 'Shopee vs Non-Shopee',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'loan_outstanding_change_credit_by_type',
                reportLabel: 'Shopee vs Non-Shopee',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'loan_outstanding_change_credit_by_type',
                reportLabel: 'Shopee vs Non-Shopee',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'loan_disbursement_credit_by_type',
                reportLabel: 'Shopee vs Non-Shopee',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'loan_disbursement_credit_by_type',
                reportLabel: 'Shopee vs Non-Shopee',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'loan_repayment_credit_by_type',
                reportLabel: 'Shopee vs Non-Shopee',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'loan_repayment_credit_by_type',
                reportLabel: 'Shopee vs Non-Shopee',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
        ]
    }

    getBorrowerConfigDicts() {
        return [
            {
                metric: 'cumulative_borrower',
                reportLabel: 'Cumulative Borrowers',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'cumulative_borrower',
                reportLabel: 'Cumulative Borrowers',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'new_borrower',
                reportLabel: 'New Borrowers',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'new_borrower',
                reportLabel: 'New Borrowers',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'outstanding_borrower',
                reportLabel: 'Outstanding Borrowers',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'outstanding_borrower',
                reportLabel: 'Outstanding Borrowers',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'cumulative_borrower_by_type',
                reportLabel: 'Loan Type',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'cumulative_borrower_by_type',
                reportLabel: 'Loan Type',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'new_borrower_by_type',
                reportLabel: 'Loan Type',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'new_borrower_by_type',
                reportLabel: 'Loan Type',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'new_borrower_mari_by_type',
                reportLabel: 'Non Split Txn vs Split Payment',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'new_borrower_mari_by_type',
                reportLabel: 'Non Split Txn vs Split Payment',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'new_borrower_cashloan_by_type',
                reportLabel: 'Instant Loan vs Balance Transfer',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'new_borrower_cashloan_by_type',
                reportLabel: 'Instant Loan vs Balance Transfer',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'outstanding_borrower_by_type',
                reportLabel: 'Loan Type',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'outstanding_borrower_by_type',
                reportLabel: 'Loan Type',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'outstanding_borrower_mari_by_type',
                reportLabel: 'Non Split Txn vs Split Payment',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'outstanding_borrower_mari_by_type',
                reportLabel: 'Non Split Txn vs Split Payment',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'outstanding_borrower_cashloan_by_type',
                reportLabel: 'Instant Loan vs Balance Transfer',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'outstanding_borrower_cashloan_by_type',
                reportLabel: 'Instant Loan vs Balance Transfer',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'outstanding_borrower_non_split_txn_by_type',
                reportLabel: 'Interest-free vs Revolving',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'outstanding_borrower_non_split_txn_by_type',
                reportLabel: 'Interest-free vs Revolving',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'outstanding_borrower_split_payment_by_type',
                reportLabel: 'Interest-free vs Revolving',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'outstanding_borrower_split_payment_by_type',
                reportLabel: 'Interest-free vs Revolving',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'outstanding_borrower_split_bill_by_type',
                reportLabel: 'Interest-free vs Revolving',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'outstanding_borrower_split_bill_by_type',
                reportLabel: 'Interest-free vs Revolving',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'cumulative_borrower_sme_by_type',
                reportLabel: 'RCF vs Term Loan',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'cumulative_borrower_sme_by_type',
                reportLabel: 'RCF vs Term Loan',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'cumulative_borrower_mari_by_type',
                reportLabel: 'Non Split Txn vs Split Payment',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'cumulative_borrower_mari_by_type',
                reportLabel: 'Non Split Txn vs Split Payment',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'cumulative_borrower_cashloan_by_type',
                reportLabel: 'Instant Loan vs Balance Transfer',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'cumulative_borrower_cashloan_by_type',
                reportLabel: 'Instant Loan vs Balance Transfer',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'new_borrower_sme_by_type',
                reportLabel: 'RCF vs Term Loan',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'new_borrower_sme_by_type',
                reportLabel: 'RCF vs Term Loan',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'outstanding_borrower_sme_by_type',
                reportLabel: 'RCF vs Term Loan',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'outstanding_borrower_sme_by_type',
                reportLabel: 'RCF vs Term Loan',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'outstanding_borrower_credit_by_type',
                reportLabel: 'Shopee vs Non-Shopee',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'outstanding_borrower_credit_by_type',
                reportLabel: 'Shopee vs Non-Shopee',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'new_borrower_credit_by_type',
                reportLabel: 'Shopee vs Non-Shopee',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'new_borrower_credit_by_type',
                reportLabel: 'Shopee vs Non-Shopee',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'cumulative_borrower_credit_by_type',
                reportLabel: 'Shopee vs Non-Shopee',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'cumulative_borrower_credit_by_type',
                reportLabel: 'Shopee vs Non-Shopee',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
        ]
    }

    getInvestmentConfigDicts() {
        return [
            {
                metric: 'investment_aua',
                reportLabel: 'Investment AUA',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'investment_aua',
                reportLabel: 'Investment AUA',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'investment_aua_change',
                reportLabel: 'AUA Change',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'investment_aua_change',
                reportLabel: 'AUA Change',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'investment_aua_by_type',
                reportLabel: 'Fund Type',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'investment_aua_by_type',
                reportLabel: 'Fund Type',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'investment_aua_change_by_type',
                reportLabel: 'Fund Type',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'investment_aua_change_by_type',
                reportLabel: 'Fund Type',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
        ]
    }

    getCardConfigDicts() {
        return [
            {
                metric: 'card_txn',
                reportLabel: 'Card Txn',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'card_txn',
                reportLabel: 'Card Txn',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'card_tpv',
                reportLabel: 'Card TPV',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'card_tpv',
                reportLabel: 'Card TPV',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'card_outstanding_balance',
                reportLabel: 'Card Outstanding Balance',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'card_outstanding_balance',
                reportLabel: 'Card Outstanding Balance',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'card_txn_by_type',
                reportLabel: 'Shopee vs Non-Shopee',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'card_txn_by_type',
                reportLabel: 'Shopee vs Non-Shopee',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'card_tpv_by_type',
                reportLabel: 'Shopee vs Non-Shopee',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'card_tpv_by_type',
                reportLabel: 'Shopee vs Non-Shopee',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'card_outstanding_balance_by_type',
                reportLabel: 'Shopee vs Non-Shopee',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
                productGroup: 'money_api',
            },
            {
                metric: 'card_outstanding_balance_by_type',
                reportLabel: 'Shopee vs Non-Shopee',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            }
        ]
    }

    getExistingUserConfigDicts() {

        return [
            {
                metric: 'biz_txn_user',
                reportLabel: 'Txn User',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'txn_user',
                reportLabel: 'APP Txn User',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'mtu_to_dtu_ratio',
                reportLabel: 'APP MTU-DTU Ratio',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'mau_to_dau_ratio',
                reportLabel: 'MAU-DAU Ratio',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
            {
                metric: 'average_login_times',
                reportLabel: 'Average Login Times',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
                productGroup: 'money_api',
            },
        ]
    }


    getMatchUrl() {
        return '/seabank';
    }
}

export { SeaBankRouter };
